import { Circle, Fill, Stroke, Style, Text } from 'ol/style';
import Feature from 'ol/Feature';
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import 'ol/ol.css';
import {Draw} from 'ol/interaction';
import {Modify} from 'ol/interaction';
import Polygon from 'ol/geom/Polygon';
import Point from 'ol/geom/Point';
import * as olProj from 'ol/proj';

export default class PfsPolygon{

    constructor(){
        this.featureStyleRaw = () => {
            return new Style({
                stroke: new Stroke({
                    color: 'rgba(255, 99, 71, 0.8)',
                    width: 3
                }),
                fill: new Fill({
                    color: 'rgba(0, 50, 0, 0.3)'
                }),
                image: new Circle({
                    radius: 7,
                    fill: new Fill({
                    color: '#8c0d4c'
                    })
                }),
            });
            
        };

        this.featureStyleSelected = (feature) => {
            const index = feature.get("index").toString();
            return new Style({
                stroke: new Stroke({
                    color: 'rgba(230, 255, 0, 0.7)',
                    width: 3
                }),
                fill: new Fill({
                    color: 'rgba(0, 50, 0, 0.3)'
                }),
                image: new Circle({
                    radius: 7,
                    fill: new Fill({
                    color: '#8c0d4c'
                    })
                }),
                text: new Text({
                    font: '12px Calibri,sans-serif',
                    overflow: true,
                    fill: new Fill({
                        color: '#000',
                    }),
                    stroke: new Stroke({
                        color: '#fff',
                        width: 3,
                    }),
                    text: index,
                }),
            });
            
        };

        this.featureStyleFunction = (feature) => {
            const index = feature.get("index").toString();
            return new Style({
                stroke: new Stroke({
                    color: 'rgba(0, 255, 0, 1.0)',
                    width: 3
                }),
                fill: new Fill({
                    color: 'rgba(0, 50, 0, 0.3)'
                }),
                image: new Circle({
                    radius: 7,
                    fill: new Fill({
                    color: '#8c0d4c'
                    })
                }),
                text: new Text({
                    font: '12px Calibri,sans-serif',
                    overflow: true,
                    fill: new Fill({
                        color: '#000',
                    }),
                    stroke: new Stroke({
                        color: '#fff',
                        width: 3,
                    }),
                    text: index,
                }),
            });
            
        };

        this.modifyStyleFunction = (feature) => {
            const index = feature.get("index").toString();
            const style = new Style({
                fill: new Fill({
                    color: 'rgba(0,0,255,0.3)'
                }),
                stroke: new Stroke({
                    color: '#ffcc33',
                    width: 2
                }),
                image: new Circle({
                    radius: 7,
                    fill: new Fill({
                    color: '#ffcc33'
                    })
                }),
                text: new Text({
                    font: '12px Calibri,sans-serif',
                    overflow: true,
                    fill: new Fill({
                        color: '#000',
                    }),
                    stroke: new Stroke({
                        color: '#fff',
                        width: 3,
                    }),
                    text: index,
                }),
            });
            return style;
            
        };

        this.featureSignBoard = () => {
            var fill = new Fill({
                color: '#E53935',
              });
              var stroke = new Stroke({
                color: '#B71C1C',
                width: 1.25
              });
            return new Style({
                image: new Circle({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
            });
          };
        this.source = new VectorSource({});
        this.layer = new VectorLayer({
            opacity: 100,
            visible: true,
            source: this.source,
            // style: this.featureStyleFunction,
            zIndex: 5,
        });
        this.layerSignBoard = new VectorLayer({
            opacity: 100,
            visible: true,
            source: this.source,
            style: this.featureSignBoard,
            zIndex: 6,
        });

        this.mode = null;
        this.modify = null;
        this.onDrawEnd = null;
        this.map = null;
        this.draw = new Draw({
            source: this.source,
            type: 'Polygon',
        });
        this.polygon = null;
        
    }

    drawPolygonOnMap(array_polygons, style) {
        const features = this.layer.getSource().getFeatures();
        features.forEach((feature) => {
            this.layer.getSource().removeFeature(feature);
        });

        const lonLatFeatures = [];
        array_polygons.forEach(element => {
            const id = element["Id"];
            const list_points = element["points"];
            const list_polygons = [];
            list_points.forEach(element => {
                // const point = [element['POINT_X'], element['POINT_Y']];
                const point = olProj.fromLonLat([element['POINT_X'], element['POINT_Y']]);
                list_polygons.push(point);
            });
            const pf = new Polygon([list_polygons]);
            var marker = new Feature({
                geometry: pf,
                type: 'Feature',
            });
            marker.setStyle(style);
            marker.setId(id);
            marker.set("index", element["index"]);
            lonLatFeatures.push(marker);
        });

        this.layer.getSource().addFeatures(lonLatFeatures);
    }

    setModify(map, feature, onModifyEnd) {
        this.polygon = feature;
        this.onModifyEnd = onModifyEnd;
        this.map = map;
        this.map.removeInteraction(this.modify);
        const source = new VectorSource();
        source.addFeature(this.polygon);

        this.modify = new Modify({
            source: source,
            pixelTolerance: 10,
        });

        this.modify.on('modifyend', (evt) => {
            const feature = evt.features.item(0);
            feature.setStyle(
                this.featureStyleFunction,
            );
            this.onModifyEnd(); 
        });
        
        this.map.addInteraction(this.modify);
    }

    removeFeature(features) {
        features.forEach(info => {
            const id = info.getId();
            const index = info.get("index");
            const feature = this.source.getFeatureById(id);
            if (feature) {
                this.source.removeFeature(feature);
            }
            const features = this.source.getFeatures();
            features.forEach(element => {
                const element_index = element.get("index");
                if (element_index < index) {
                    return;
                } else {
                    const new_index = element_index - 1;
                    element.set("index", new_index)
                    element.setId(new_index)
                }
            });
            
        });
    }

    drawRawPolygon(array_polygons) {
        const features = this.layer.getSource().getFeatures();
        features.forEach((feature) => {
            this.layer.getSource().removeFeature(feature);
        });

        const lonLatFeatures = [];
        array_polygons.forEach(element => {
            const raw_polygon = JSON.parse(element.coordinates);
            const list_points = raw_polygon.list;
            const list_polygons = [];
            list_points.forEach(element => {
                // const point = [element['POINT_X'], element['POINT_Y']];
                const point = olProj.fromLonLat([element['POINT_X'], element['POINT_Y']]);
                list_polygons.push(point);
            });
            const pf = new Polygon([list_polygons]);
            var marker = new Feature({
                geometry: pf,
                type: 'Feature',
            });
            marker.setStyle(this.featureStyleRaw);
            // marker.setId(id);
            marker.set("index", "");
            lonLatFeatures.push(marker);
        });
        this.layer.getSource().addFeatures(lonLatFeatures);
    }

    //看板情報

    setSourceSignBoard(data) {
        this.layerSignBoard.getSource().clear();
        const marker = new Feature({
            geometry: new Point(olProj.fromLonLat([data['longitude'], data['latitude']])),
            // geometry: new Point([data['longitude'], data['latitude']]),
            type: "point",
        });
        marker.setStyle(this.featureSignBoard());
        const vectorSource = new VectorSource({
            features: [marker],
        });
        this.layerSignBoard.setSource(vectorSource);
      }
}
